import React, { useState, useEffect } from 'react'
import { Form, Table, message, Button, InputNumber, Input, Typography, Popconfirm } from 'antd'
import { STriggerModal } from 'shj-components'
import {
  httpAchievementDateDayDetails,
  httpAchievementDateDaySave,
  httpAchievementDateDayUpdate,
} from '@/services/customerServices'
import { DailyProps, DayItem, DayTableCellProps } from '../type'
import { min } from 'lodash-es'

const EditableCell: React.FC<DayTableCellProps> = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}) => {
  const inputNode = inputType === 'number' ? <InputNumber step="0.0001" min={0} /> : <Input />

  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{ margin: 0 }}
          rules={[
            {
              required: true,
              message: `请输入 ${title}!`,
            },
          ]}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  )
}

const EditableTable: React.FC<any> = (props: any) => {
  const { id } = props
  const [form] = Form.useForm()
  const [data, setData] = useState<DayItem[]>([])
  const [editingKey, setEditingKey] = useState<number>(-999999)

  const isEditing = (record: DayItem) => record.id === editingKey

  const edit = (record: Partial<DayItem> & { id: React.Key }) => {
    form.setFieldsValue({ amount: '', ...record })
    setEditingKey(record.id)
  }

  const cancel = () => {
    setEditingKey(-999999)
  }

  const save = async (key: React.Key) => {
    try {
      const row = (await form.validateFields()) as DayItem
      httpAchievementDateDayUpdate({ id: key, amount: row.amount }).then(() => {
        message.success('修改成功')
        const newData = [...data]
        const index = newData.findIndex(item => key === item.id)
        if (index > -1) {
          const item = newData[index]
          newData.splice(index, 1, {
            ...item,
            ...row,
          })
          setData(newData)
          setEditingKey(-999999)
        } else {
          newData.push(row)
          setData(newData)
          setEditingKey(-999999)
        }
      })
    } catch (errInfo) {
      console.log('Validate Failed:', errInfo)
    }
  }
  const columns = [
    {
      title: '日',
      dataIndex: 'dayStr',
      width: 140,
    },
    {
      title: '日目标（万）',
      dataIndex: 'amount',
      width: 240,
      editable: true,
    },
    {
      title: '操作',
      width: 140,
      dataIndex: 'operation',
      render: (_: any, record: DayItem) => {
        const editable = isEditing(record)
        return editable ? (
          <span>
            <Button onClick={() => save(record.id)} style={{ marginRight: 8 }}>
              保存
            </Button>
            <Popconfirm title="是否取消?" oktext="是" canceltext="否" onConfirm={cancel}>
              <a>取消</a>
            </Popconfirm>
          </span>
        ) : (
          <Typography.Link disabled={editingKey != -999999} onClick={() => edit(record)}>
            修改
          </Typography.Link>
        )
      },
    },
  ]
  const mergedColumns = columns.map(col => {
    if (!col.editable) {
      return col
    }
    console.log(col)
    return {
      ...col,
      onCell: (record: DayItem) => ({
        record,
        inputType: 'number',
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    }
  })
  useEffect(() => {
    httpAchievementDateDayDetails({ achievementId: id }).then((resp: any[]) => {
      setData(resp)
    })
  }, [id])
  return (
    <Form form={form} component={false}>
      <Table
        components={{
          body: {
            cell: EditableCell,
          },
        }}
        rowKey="id"
        bordered
        dataSource={data}
        columns={mergedColumns}
        rowClassName="editable-row"
        pagination={{
          onChange: cancel,
        }}
      />
    </Form>
  )
}

const DailyTarget: React.FC<DailyProps> = ({
  rowData = { year: '', month: '' },
  isVisible,
  setIsVisible,
}) => {
  return (
    <STriggerModal
      width={600}
      title={rowData.year + '年' + rowData.month + '月签单业绩目标'}
      open={isVisible}
      cancelText="取消"
      onCancel={() => {
        setIsVisible(false)
      }}
      footer={false}
    >
      <EditableTable id={rowData.id} />
    </STriggerModal>
  )
}

export default DailyTarget
